<form class="f-col blank-form" [formGroup]="divisionForm">
    <div class="section-heading">
        <h2 class="h2-heading">{{content?.['b2b.managecompany.dddivisiondetails']}}</h2>
        <a tabindex="0" role="button" class="link" (keydown.enter)="addNewDivision()" (click)="addNewDivision()" *ngIf="tableData.length > 0 &&  !Addnew"><mat-icon fontSet="material-symbols-outlined"
            class="edit-icon" >add</mat-icon> {{content?.['b2b.managecompany.addnew']}}</a>
    </div>

    <div class="section-content" *ngIf="Addnew">
        <div class="inner-contentsection">
            <div class="f-row two--ColLayout">
                <div class="f-col">
                    <mat-form-field>
                        <mat-label>{{content?.['b2b.managecompany.dddivisionname']}}</mat-label>
                        <input matInput formControlName="nameOfDivision" (keypress)="blockInvalidCharacters1($event)"
                            (paste)="onPasteBlocked($event)" (contextmenu)="disableRightClick($event)" />
                        <mat-error *ngIf="divisionForm.get('nameOfDivision')?.hasError('required') && divisionForm.get('nameOfDivision')?.touched"> Division name is required. </mat-error>
                        <mat-error *ngIf="divisionForm.get('nameOfDivision')?.hasError('duplicate') && divisionForm.get('nameOfDivision')?.touched"> This Division name aready exists. </mat-error>
                        <mat-error *ngIf="divisionForm.get('nameOfDivision')?.hasError('minlength') && divisionForm.get('nameOfDivision')?.touched">Division name must be at least 2 character.</mat-error>
                        <mat-error *ngIf="divisionForm.get('nameOfDivision')?.hasError('maxlength') && divisionForm.get('nameOfDivision')?.touched">Division name cannot exceed 100 characters.</mat-error>
                    </mat-form-field>
                </div>
            </div>

            <div class="f-row">
                <div class="f-col">
                    <div class="f-row validation-col">
                        <label class="mat-label" for="">{{content?.['b2b.managecompany.status']}}</label>
                        <mat-radio-group aria-label="Select an option" formControlName="status">
                            <mat-radio-button [value]="true">{{content?.['b2b.managecompany.active']}}</mat-radio-button>
                            <mat-radio-button [value]="false">{{content?.['b2b.managecompany.deactivate']}}</mat-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
            </div>

            
        </div>

        <div class="inner-action">
            <button mat-button class="button--secondary-small" (click)="onCancel()">{{content?.['b2b.managecompany.cancel']}}</button>
            <button mat-button class="button--primary-small" (click)="onSave()" [class.disabled]="divisionForm.invalid">
                {{content?.['b2b.managecompany.save']}}
            </button>
        </div>
    </div>

    <div class="section-table data-listing" *ngIf="tableData.length > 0 &&  !Addnew">
        <table mat-table [dataSource]="tableData" class="mat-elevation-z0">
            <!-- Division Column -->
            <ng-container matColumnDef="Division">
                <th mat-header-cell *matHeaderCellDef> {{content?.['b2b.managecompany.division']}} </th>
                <td mat-cell *matCellDef="let element"> {{ element.businessType }} </td>
            </ng-container>

            <!-- Status Column -->
            <ng-container matColumnDef="Status">
                <th mat-header-cell *matHeaderCellDef> {{content?.['b2b.managecompany.ddstatus']}} </th>
                <td mat-cell *matCellDef="let element" class="status-tag">
                    <span [ngClass]="element.status ? 'status-active' : 'status-inactive'">
                        {{ element.status ? 'Active' : 'Inactive' }}
                    </span>
                </td>
            </ng-container>

            <!-- Actions Column -->
            <ng-container matColumnDef="Actions">
                <th mat-header-cell *matHeaderCellDef> {{content?.['b2b.managecompany.ddactions']}} </th>
                <td mat-cell *matCellDef="let element" class="onclick-links">
                    <!-- <a class="onclick-cell primary-link" (click)="onEdit(element)">Edit</a> -->
                    <!-- <a class="onclick-cell warm-link" (click)="onRemove(element)">Remove</a> -->
                    <a tabindex="0" role="button" aria-label="Edit item" class="onclick-cell primary-link" (keydown.enter)="onEdit(element)" (click)="onEdit(element)"><mat-icon fontSet="material-symbols-outlined">edit</mat-icon></a>
                    <a tabindex="0" role="button" aria-label="Remove item" class="onclick-cell warm-link" (keydown.enter)="onRemove(element)" (click)="onRemove(element)"><mat-icon fontSet="material-symbols-outlined">delete</mat-icon></a>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
    </div>
<ng-container *ngIf="!isLoading && tableData.length === 0 && !Addnew">
    <app-cam-empty-state (myEvent)="handleEvent($event)" [heading]="'No divisions found'"
        [content]="'Create divisions to apply travel policies and manage workflows effectively.'"
        [navigateTo]="'/cam/company-management/division-details'">
    </app-cam-empty-state>
</ng-container>
</form>

<ng-template #selectionWarning>
    <div class="custom-dialog">
        <div class="d-justify-bw">
            <div class="custom-dialog__left">
                <div class="mat-dialog-title custom-dialog__title d-justify-bw">
                    <h2 class="mat-dialog-title"> Confirm changes</h2>
                    <!-- <div class="custom-overlay-close">
                        <mat-icon fontSet="material-symbols-outlined" class="close_icon" (click)="CloseDialog(false)">close</mat-icon>
                    </div> -->
                </div>    
                <mat-dialog-content class="custom-dialog__text">
                    <div class="custom-dialog__description">Are you sure you want to remove this Division?</div>
                </mat-dialog-content>    
                <mat-dialog-actions>
                    <div class="dialog-actions-right">
                        <button class="button--secondary-small" mat-button (click)="CloseDialog(false)">Cancel</button>
                        <button class="button--primary-small" mat-button (click)="CloseDialog(true)">Confirm</button>
                    </div>
                </mat-dialog-actions>
            </div>
        </div>
    </div>
</ng-template>